import LetterAvatar from "@/components/Avatar/LetterAvatar"
import { formatToDevanagariStyle } from "@/utilities/helper"

export const getColumns = (isWeightable) => {
  const baseColumns = [
    {
      header: "SKU",
      accessorKey: "sku",
    },
    // {
    //   header: "Name",
    //   accessorKey: "name",
    // },
    {
      header: "code",
      accessorKey: "code",
    },
    {
      header: "quantity",
      accessorKey: "quantity",
    },
    {
      header: "Dis %",
      accessorKey: "discount",
      cell: ({ row }) => `${row.original.discount} %`,
    },
  ]

  const weightColumn = {
    header: "weight",
    accessorKey: "weight",
    cell: ({ row }) => `${row.original.weight}`,
  }

  const priceColumn = {
    header: "price",
    cell: ({ row }) => {
      const { sell_price, quantity, discount } = row.original
      const total = sell_price * quantity
      const discountedTotal = total * (1 - discount / 100)
      return `Rs ${formatToDevanagariStyle(discountedTotal)}`
    },
  }

  if (isWeightable()) {
    baseColumns.push(weightColumn)
  }

  baseColumns.push(priceColumn)

  return baseColumns
}
